import { modalStore } from '@/stores/modal.store';

export type ProfileSection =
    | 'account'
    | 'jackpot'
    | 'coinflip'
    | 'casebattles'
    | 'transactions';

export interface OpenProfileOptions {
    /** Visually flag the Steam trade-link field (used when an action is blocked
     *  because the user hasn't set one yet). */
    highlightTradeLink?: boolean;
}

/** Open the profile modal (optionally on a specific section). */
export function openProfileModal(
    section: ProfileSection = 'account',
    options: OpenProfileOptions = {}
) {
    const { setTitle, setComponent, setData, toggleModal } = modalStore.getState();
    setTitle('PROFILE');
    setComponent('Profile');
    setData({
        modalSize: 'lg',
        section,
        highlightTradeLink: options.highlightTradeLink ?? false,
    });
    toggleModal(true);
}
